import { StyledSearchAndFilter } from './style';
import { useIntl } from 'react-intl';
import { Icon, Search } from 'ui';
import { Button } from 'antd';
import useWindowScrollTop from 'utils/useWindowScrollTop';
import {
  useFilterDispatch,
  useFilterState,
} from 'public/context/FilterContext';
import { useBreakpoint } from 'utils/useBreakpoint';

interface Props {
  rootClassName?: string;
  isMenuOpen?: boolean;
  searchLabel?: string;
  scrollThreshold?: number;
  isFarmSearch?: boolean;
  isFixed?: boolean;
  hideSearch?: boolean;
}

const SearchAndFilter = ({
  rootClassName = 'search-section-box',
  isMenuOpen = false,
  searchLabel,
  scrollThreshold = 90,
  isFarmSearch = false,
  isFixed = false,
  hideSearch = false,
}: Props) => {
  const intl = useIntl();
  const scrollPosition = useWindowScrollTop(350);
  const data = useFilterState();
  const dispatchFilter = useFilterDispatch();
  const { isLgDown } = useBreakpoint();

  return isLgDown ? (
    <StyledSearchAndFilter
      className={`${rootClassName} ${isMenuOpen ? 'search-section-open' : ''}`}
    >
      <div
        className={`search-section ${scrollPosition > scrollThreshold || isFixed ? 'search-section-fixed' : ''} ${hideSearch ? 'search-section-no-search' : ''}`}
      >
        {data.isFilter && (
          <Button
            form="filter-form"
            className="filter-open-btn"
            onClick={() => {
              data.openCloseDrawer();
              dispatchFilter({
                type: 'SAVE_PAYLOAD',
                payload: {
                  isOpenMobileFilter: true,
                },
              });
            }}
          >
            <Icon name={'filter-settings-icon'} />
            <span>{intl.formatMessage({ id: 'general.filter' })}</span>
          </Button>
        )}

        {!hideSearch && (
          <Search
            placeholder={
              searchLabel
                ? searchLabel
                : intl.formatMessage({
                    id: isFarmSearch
                      ? 'mobile_header.farm_search'
                      : 'mobile_header.search',
                  })
            }
            prefix={<Icon name={'mobile-search-icon'} />}
          />
        )}
      </div>
    </StyledSearchAndFilter>
  ) : null;
};

export default SearchAndFilter;
